module.exports = __webpack_public_path__ + "img/overview1.6366c5b8.jpg";